import { render, staticRenderFns } from "./chainPriceTab.vue?vue&type=template&id=2ad1a7e2&"
import script from "./chainPriceTab.vue?vue&type=script&lang=js&"
export * from "./chainPriceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports